var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResetRsvpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    width: 22,
    height: 22,
    viewBox: "0 0 1025 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#728096",
    d: "M591.963942 6.17051C409.548578-22.304204 233.4705 49.707042 121.688176 182.211672l-3.617789-81.387966a59.065957 59.065957 0 0 0-61.625482-56.4326A59.065957 59.065957 0 0 0 0.061527 106.016588l9.610523 216.365983a59.065957 59.065957 0 0 0 61.625482 56.383378l216.365983-9.610524a59.065957 59.065957 0 0 0 56.346462-61.613176 59.065957 59.065957 0 0 0-61.588566-56.420294l-66.793752 2.965603c84.242821-97.05275 213.941818-150.445914 349.067499-132.52924 227.908456 30.234387 382.341322 250.279687 333.193524 474.853376-45.160846 206.373992-246.243513 341.290482-455.607719 302.909915a393.071637 393.071637 0 0 1-278.680568-206.263243 58.942903 58.942903 0 0 0-78.237782-25.533721 59.065957 59.065957 0 0 0-26.395099 80.428145c70.411543 135.359484 200.319732 237.925057 362.012788 267.568784 274.287537 50.218369 537.561734-128.210043 593.600561-399.901138C1073.536071 329.765815 880.34117 51.183691 591.963942 6.17051z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetRsvpIcon);
export default __webpack_public_path__ + "static/media/reset_rsvp_icon.6a2d7554da20f958ff195595ef326d4d.svg";
export { ForwardRef as ReactComponent };